module.exports = __webpack_public_path__ + "img/qrcode-547.74ebb2cb.png";